/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */
import React from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

import { ROUTES } from '@futrli/shared-services';
import { UILoader } from '@futrli/ui-components';

import * as styles from './initial-onboarding-nav.scss';

export const InitialOnboardingLoader = () => {
  return (
    <>
      <nav className={styles.navContainer}></nav>
      <div className={styles.progressiveBarContainer}>
        <div className={classNames(styles.progressBar)} style={{ width: '30%' }} />
      </div>
      <UILoader isFull />
    </>
  );
};

export const InitialOnboardingNav = () => {
  const { pathname } = useLocation();

  const initialWidth = 15;
  let currentWidth;

  if (pathname.indexOf(ROUTES.FORECAST_START) !== -1) {
    currentWidth = initialWidth;
  }

  if (pathname.indexOf(ROUTES.BUDGET_DATE_SELECT) !== -1) {
    currentWidth = initialWidth * 2;
  }

  if (pathname.indexOf(ROUTES.SCENARIO_TYPE) !== -1) {
    currentWidth = initialWidth * 2;
  }

  return (
    <>
      <nav className={styles.navContainer}></nav>
      <div className={styles.progressiveBarContainer}>
        <div
          data-testid="progressbar-test-id"
          className={classNames(styles.progressBar)}
          style={{ width: `${currentWidth}%` }}
        />
      </div>
    </>
  );
};
